import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { base_url } from "../../data/constants";

export const fetchProducts = createAsyncThunk(
  "api/products",
  async (query, thunkApi) => {
    try {
      const { data } = await axios.get(
        `${base_url}api/products/bystore${query ? "/" + query : ""}`
      );
      return data;
    } catch (error) {
      return thunkApi.rejectWithValue(error.message);
    }
  }
);

export const fetchCategories = createAsyncThunk(
  "api/categories",
  async (_, thunkApi) => {
    try {
      const { data } = await axios.get(`${base_url}api/categories/`);
      return data;
    } catch (error) {
      return thunkApi.rejectWithValue(error.message);
    }
  }
);
